import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import AuctionDetails from '../Pages/AuctionDetails'



function AuctionDetailsLayout() {
  return (
   <>
   <Header />
    <AuctionDetails />
   <Footer />
   </>
  )
  
}

export default AuctionDetailsLayout